import React, { Component, Fragment } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, formValueSelector, change } from 'redux-form';

import { TextField, DatePicker, SelectField } from 'redux-form-material-ui';

import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';

import moment from 'moment';

class RecurringFields extends Component {
  displayFrequencyTypes = frequency => {
    let frequencyTypes = [
      <MenuItem key={2} value={2} primaryText={frequency > 1 ? 'Days' : 'Day'} />,
      <MenuItem key={3} value={3} primaryText={frequency > 1 ? 'Weeks' : 'Week'} />,
      <MenuItem key={4} value={4} primaryText={frequency > 1 ? 'Months' : 'Month'} />,
      <MenuItem key={5} value={5} primaryText={frequency > 1 ? 'Years' : 'Year'} />,
    ];

    return frequencyTypes.map(item => {
      return item;
    });
  };

  onScheduleStartDateChange = (_, value) => {
    this.props.changeFieldValue('transaction_date', value);
  };

  render() {
    let maxDate;
    if (this.props.schedule_end_date) {
      maxDate = moment(this.props.schedule_end_date)
        .subtract(1, 'days')
        .toDate();
    }

    let minDate;
    if (this.props.schedule_start_date) {
      minDate = moment(this.props.schedule_start_date)
        .add(1, 'days')
        .toDate();
    }

    return (
      <Fragment>
        <div className="row">
          <div className="col-sm-12">
            <Field
              name="schedule_name"
              component={TextField}
              multiLine={false}
              fullWidth
              validate={[validator.required]}
              floatingLabelText="Name"
              style={{ marginTop: '-15px', fontSize: '14px' }}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: '0px' }}>
          <div className="col-sm-6">
            <Field
              name="schedule_start_date"
              maxDate={maxDate}
              component={DatePicker}
              formatDate={formatter.reformatDate}
              autoOk={true}
              textFieldStyle={{ width: '100%', fontSize: '14px' }}
              floatingLabelText="First Trigger Date"
              style={{
                marginTop: '-22px',
              }}
              validate={[validator.required]}
              onChange={this.onScheduleStartDateChange}
            />
          </div>

          <div className="col-sm-6">
            <Field
              name="schedule_end_date"
              minDate={minDate}
              component={DatePicker}
              formatDate={formatter.reformatDate}
              autoOk={true}
              textFieldStyle={{ width: '100%', fontSize: '14px' }}
              floatingLabelText="End Date"
              style={{
                marginTop: '-22px',
              }}
            />
          </div>
        </div>

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-3">Repeat every</div>

          <div className="col-xs-3">
            <Field
              name="schedule_frequency"
              component={TextField}
              multiLine={false}
              fullWidth
              validate={[validator.required]}
              normalize={formatter.onlyPositiveNumbers}
              style={{ marginTop: '-10px', fontSize: '14px' }}
            />
          </div>

          <div className="col-xs-6">
            <Field
              name="schedule_frequency_type"
              component={SelectField}
              multiLine={false}
              fullWidth
              validate={[validator.required]}
              style={{ marginTop: '-10px', fontSize: '14px' }}
            >
              {this.displayFrequencyTypes(this.props.schedule_frequency)}
            </Field>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  schedule_frequency: formValueSelector(ownProps.formName)(state, 'schedule_frequency'),
  schedule_start_date: formValueSelector(ownProps.formName)(state, 'schedule_start_date'),
  schedule_end_date: formValueSelector(ownProps.formName)(state, 'schedule_end_date'),
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      changeFieldValue: (field, value) => change(ownProps.formName, field, value),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RecurringFields);
